import { useTranslation } from "react-i18next";
// Redux
import { useSelector } from "react-redux";
// Constants
import { project, supportInfo, JUST4UInfo, strackSupportInfo } from "../../config/constants";
// Components
import { SupportDiv, Text, Span, Link } from "./styles";
import Title from "../title";

const Support = () => {
  const hospitalName = useSelector(({ clinician }) => clinician.data.HOSPITAL_NAME);
  const [t] = useTranslation("global");

  const renderJUST4UInformation = () => {
    return (
      <>
        <Text margin="20px 0 5px 0">
          <Span>{t("JUST4UDetails")}</Span>
        </Text>
        <Text>
          {t("support_landLine")} <Span>{JUST4UInfo.landline}</Span>
        </Text>
        <Text>
          {t("support_email")} <Span>{JUST4UInfo.email}</Span>
        </Text>
        <Text margin="5px 0 0 0">
          <Span>{JUST4UInfo.web}</Span>
        </Text>
        <Text>{t("JUST4UAddress")}</Text>
      </>
    );
  };

  const renderGlobalInfo = () => {
    return (
      <>
        <Title title={t("support_title")} marginBottom="10px" />
        <SupportDiv>
          <Text>{t("support_supportText")}</Text>
          <Text margin="20px 0 0">
            {t("support_landLine")} <Span>{supportInfo.landline}</Span>
          </Text>
          <Text>
            {t("support_mobile")} <Span>{supportInfo.mobile}</Span>
          </Text>
          <Text margin="20px 0">
            <Span>{supportInfo.email}</Span>
          </Text>
          <Text margin="0 0 20px" maxWidth="185px">
            {t("support_address")}
          </Text>
          <Span>{supportInfo.web}</Span>
          {hospitalName === "JUST4U" && renderJUST4UInformation()}
        </SupportDiv>
      </>
    );
  };

  const renderStrackInfo = () => {
    return (
      <>
        <Title title={t("support_title")} marginBottom="10px" />
        <SupportDiv>
          <Text>
            <Span>1. {t("support_assistanceStrack1")}</Span>
          </Text>
          <Text margin="5px 0 0">{strackSupportInfo.mobile1}</Text>
          <Text margin="5px 0 0">{strackSupportInfo.mobile2}</Text>
          <Text margin="10px 0 0">
            <Span>{t("support_supportStrackText")}</Span>
          </Text>
          <Text margin="10px 0 0">{t("support_scheduleDaysStrack")}</Text>
          <Text margin="10px 0 0">08:00 - 18:00</Text>
          <Text margin="20px 0 0">
            <Span>2. {t("support_assistanceStrack2")}</Span>
          </Text>
          <Text margin="10px 0 10px">
            {t("support_supportStrackText2")} <Span>Roche Dialog:</Span>
          </Text>
          <Link href="http://dialog.roche.com" target="_blank">
            {strackSupportInfo.web}
          </Link>
        </SupportDiv>
      </>
    );
  };

  const renderSupportInfo = {
    global: renderGlobalInfo(),
    strack: renderStrackInfo(),
  };

  return renderSupportInfo[project];
};

export default Support;
